import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { IOrcamento } from "app/types/IOrcamento"
import { AlterarValidadePedido } from "./AlterarValidadePedido"
import { DataFormatoEN } from "app/types/DataFormatoEN"

export type AlterarValidadePedidoContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>
}

export type DadosOrcamentoAlterarValidade = {
    Numero: number
    Filial: string
    ValorDesconto: number
    ValorPedido: number
    Validade: Date
    DataPedido: Date 
    OidCliente: number
    NomeCliente: string
    CnpjCPfCliente: string
    Logradouro: string
    NumeroEndereco: string
    ComplementoEndereco: string
    Bairro: string
    Cep: string
    Cidade: string
    UF: string
    Telefone: string
    FormaDePagamento: string
    TipoDeDocumento: string
}

export const AlterarValidadePedidoContainer = (props: AlterarValidadePedidoContainerProps) => {

    const [dadosPedido, setDadosPedido] = useState<DadosOrcamentoAlterarValidade>(null)
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    const [processando, setProcessando] = useState<boolean>(null)
    
    const obterDadosPedido = async () => {
        try {
            
            var tipoOrcamento = props.orcamentoSelecionado.TipoOrcamento
            const resultado = await microuniversoApi.Orcamento.ObterDadosPedidoAlterarValidade( 
                    props.orcamentoSelecionado.NumeroPedido, 
                )
            if (!resultado || "HasErrors" in resultado) {
                onVoltar()
                return
            }
           setDadosPedido(resultado)
        } catch (e) {
            tratamentoErroPadrao(e)
        }
    }

    const onExcluirControleDeExclusividade = async () => {
        try {
            globalMU.blockUI()
            await microuniversoApi.Comum.excluirControleDeExclusividade(props.orcamentoSelecionado.NumeroPedido.toString(), "PEDICLICAD")
        }
        catch (erro) {
            tratamentoErroPadrao(erro)
        }
        finally {
            globalMU.unblockUI()
        }
    }


    const onAlterarDataValidade = async (novaDataValidade: DataFormatoEN) => {
        if (novaDataValidade == null) {
            globalMU.showErrorMessage("Informe a nova data de validade!")
            return
        }

        const dataValidar = new Date(novaDataValidade)
        const dataPedido = new Date(dadosPedido.DataPedido)
        if (dataValidar < dataPedido )  
        {
            globalMU.showErrorMessage("Data de validade inferior a data do pedido!")

            return
        }
        try {
            globalMU.blockUI()
            setProcessando(true)
            const resposta = await microuniversoApi.Orcamento.AlterarDataValidadePedido(dadosPedido.Numero, novaDataValidade)
            if (resposta) {
                globalMU.showSuccessMessage("Data de validade alterada com sucesso!")
                onVoltar()
                return
            }   

        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            setProcessando(false)
            globalMU.unblockUI()
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
        dadosPedido != null 
            && passo == "Pesquisa de Orçamento" 
            && onExcluirControleDeExclusividade()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
        dadosPedido != null 
            && onExcluirControleDeExclusividade()
    }

    useEffect(() => {
        globalMU.blockUI()
        passosInterno.current.set("Alterar Validade do Orçamento", () => { })
        obterDadosPedido()
    }, [])

    useEffect(() => {
        if (dadosPedido !== null && dadosPedido.Numero > 0) {
            globalMU.unblockUI()
        }
    }, [dadosPedido])

    useEffect(() => {
        $.connection.hub.disconnected(function () {
            //onVoltar()
        });
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                id="AlterarValidadePedidoBreadcrumb"
            />

            {dadosPedido != null &&
                <AlterarValidadePedido
                    dadosPedido={dadosPedido}
                    onAlterarDataValidade={onAlterarDataValidade}
                    processando={processando}
                />
            }
        </>
    )

}